/**
 * Enum for Kds Order Status.
 * @readonly
 * @enum {String} KdsOrderStatusEnum
 */

const KdsOrderStatusEnum = {
  OPEN    : 'open',
  HOLD    : 'hold',
  COMPLETE: 'complete',
  CANCEL  : 'cancel'
}

export default KdsOrderStatusEnum
